var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgThreeLines = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 5.4C3 4.90294 3.40294 4.5 3.9 4.5L20.1 4.5C20.5971 4.5 21 4.90294 21 5.4C21 5.89706 20.5971 6.3 20.1 6.3H3.9C3.40294 6.3 3 5.89706 3 5.4ZM3 11.7C3 11.2029 3.40294 10.8 3.9 10.8H14.7C15.1971 10.8 15.6 11.2029 15.6 11.7C15.6 12.1971 15.1971 12.6 14.7 12.6H3.9C3.40294 12.6 3 12.1971 3 11.7ZM3 18C3 17.5029 3.40294 17.1 3.9 17.1H20.1C20.5971 17.1 21 17.5029 21 18C21 18.4971 20.5971 18.9 20.1 18.9H3.9C3.40294 18.9 3 18.4971 3 18Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgThreeLines);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ThreeLines.9fcb2a5526652e6664900ba4ff7d41e9.svg";